/**
 * useGlobalBadgeCount — aggregates badge-worthy counts for the document title.
 *
 * Returns the total count of "attention" items (inbox + pending invites).
 * Used by ViewShell to show a global badge in the tab title even when
 * the user is on a view other than Inbox.
 *
 * @see §3.7 Fas 4 in OBSERVABILITY_ANALYTICS_REMINDERS_PLAN.md
 */

import { useStaticDataImmediate } from "@/features/static-data/useStaticData"
import { useObservable } from "dexie-react-hooks"
import { db } from "@/db/schema"

/**
 * Returns the global badge count (inbox + invites).
 */
export function useGlobalBadgeCount(): number {
  const [data] = useStaticDataImmediate()
  const invites = useObservable(db.cloud.invites)
  const pendingInvites = invites?.filter(i => !i.accepted && !i.rejected).length ?? 0

  return data.counters.inbox + pendingInvites
}
